export default {"src":"/_next/static/media/text-file.6a2fd8e5.svg","height":50,"width":36,"blurWidth":0,"blurHeight":0};